import { IReactChildren } from '~/src/dash/types/props';

export interface IAppBaseClassProps extends IReactChildren {
  id: string;
}

export function BaseClass({ id, children }: IAppBaseClassProps) {
  if (document.firstElementChild) {
    document.firstElementChild.id = 'page_' + id;
  }
  return children;
}
